import { render } from "./CatalogList.vue?vue&type=template&id=4390f9c1&scoped=true"
import script from "./CatalogList.vue?vue&type=script&lang=js"
export * from "./CatalogList.vue?vue&type=script&lang=js"

import "./CatalogList.vue?vue&type=style&index=0&id=4390f9c1&scoped=true&lang=less"

import exportComponent from "/home/huiwen/TeamCity/buildAgent/work/78c9eac71a3ca1e9/webs/pdam-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4390f9c1"]])

export default __exports__